import './general_attachment_view.js.coffee'

Customer.Conversation ||= {}
Customer.Conversation.Attachments ||= {}

class Customer.Conversation.Attachments.FacebookCommentAttachmentsView extends Customer.Conversation.Attachments.GeneralAttachmentsView
  template: JST['backbone/templates/customer/conversation/attachments/facebook_comment_attachments']
